export default __webpack_public_path__ + "static/media/alert-orange.435017ca.svg";